__webpack_require__.p = "/random-quotes/";